// Toggle between dark (default) and light, persisting the choice.
// The initial theme is set inline in default.hbs <head> to avoid a flash.
export default function themeToggle() {
    const button = document.querySelector('.gh-theme-toggle');
    if (!button) {
        return;
    }
    button.addEventListener('click', function () {
        const current = document.documentElement.getAttribute('data-theme') === 'light' ? 'light' : 'dark';
        const next = current === 'light' ? 'dark' : 'light';
        document.documentElement.setAttribute('data-theme', next);
        try {
            localStorage.setItem('theme', next);
        } catch (e) {
            // ignore storage errors (e.g. private mode)
        }
    });
}
